import { forwardRef, useImperativeHandle, useRef } from 'react'
import { Modal } from 'bootstrap'


type ModalDialogProps = {
  title: string
  message: string
  onOK: Function
  onCancel?: Function
}

export type ModalDialogRef = {
  show: Function
  hide: Function
}

export const ModalDialog = forwardRef<ModalDialogRef, ModalDialogProps>(({title, message, onOK, onCancel}, ref) => {
  
  useImperativeHandle(ref, () => ({        
    show: () => showModal(),       
    hide: () => hideModal()
  }));

  const modalRef = useRef<HTMLDivElement | null>(null);

  const showModal = () => {
    if (modalRef && modalRef.current) {
      const modalEle = modalRef.current;
      const bsModal = new Modal(modalEle, {
        backdrop: 'static',
        keyboard: false
      })
      bsModal.show()
    }    
  }

  const hideModal = () => {
    if (modalRef && modalRef.current) {
      const modalEle = modalRef.current
      const bsModal= Modal.getInstance(modalEle)
      if (bsModal) bsModal.hide()
    }
  }

  return (
  <div className="modal" ref={modalRef} data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div className="modal-dialog">
      <div className="modal-content">
        <div className="modal-header">
          <h1 className="modal-title fs-5" id="staticBackdropLabel">{title}</h1>
          <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={hideModal}></button>
        </div>
        <div className="modal-body text-center">
          {message}
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-sm btn-danger" onClick={() => { 
            if (onOK) onOK();
            hideModal();
          }}>YES</button>
          <button 
            type="button" 
            className="btn btn-sm btn-secondary" 
            data-bs-dismiss="modal" 
            onClick={() => { if (onCancel) onCancel(); hideModal();}}
          >
            No
          </button>    
        </div>
      </div>
    </div>
  </div>
  )
});